export class CampanhaPipelineCard {
    isCollapseOpened: boolean;
}
